import { render, staticRenderFns } from "./reclamaciones.vue?vue&type=template&id=d7b7531c&"
import script from "./reclamaciones.vue?vue&type=script&lang=js&"
export * from "./reclamaciones.vue?vue&type=script&lang=js&"
import style0 from "./reclamaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports